import { useEffect } from 'react'
import { useZustandStore } from 'zustandGlobalStore'

export const useSnapPixelInitialization = (): void => {
  const email = useZustandStore((state) => state.lead?.email)

  useEffect(() => {
    window.snaptr?.('init', 'b3426736-0ce2-4aab-a70c-66492cf08cd4', {
      user_email: email,
    })
    window.snaptr?.('track', 'PAGE_VIEW', { user_email: email })
  }, [email])
}
